<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M10.5,785.5v9l-2,2v3h-16v-3l-2-2v-9H10.5z M-0.5,790.5h-3v2h3v3h2v-3h3v-2h-3v-3h-2V790.5z"/>
</svg>

</template>